import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d3a84090"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "text-h4 text-weight-bold",
  id: "pageTitle"
}
const _hoisted_2 = {
  key: 0,
  class: "q-py-xs",
  id: "pageDescription"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t(_ctx.title)), 1),
    (_ctx.description)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.$t(_ctx.description)), 1))
      : _createCommentVNode("", true)
  ], 64))
}